import { HttpResponse } from '@angular/common/http';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuditResultQuestion } from 'src/app/core-module/models/Audits/AuditResults/audit-result-question';
import { QuestionAttachment } from 'src/app/core-module/models/Audits/question-attachment';
import { UtilService } from 'src/app/core-module/services/util.service';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-audit-result-detail-question',
    templateUrl: './audit-result-detail-question.component.html',
    styleUrl: './audit-result-detail-question.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuditResultDetailQuestionComponent {
  @Input() question:AuditResultQuestion = new AuditResultQuestion();
  @Input() eventId: number = -1;

  public expandedAttachmentPanel:boolean = false;
  public expandedPhotoPanel:boolean = false;
  public expandedActionPanel:boolean = false;
  public isBluebird:boolean = false;

  constructor(private util:UtilService, private router:Router, private auditService: AuditService){
    this.isBluebird = environment.blueBird;
  }

  ngOnInit(){
    this.reorderActionsByDate();
  }

  reorderActionsByDate(){
    this.question.Actions = this.question.Actions.sort((a,b)=>
      { if(!a.Resolved && b.Resolved){
        return -1 ;
      } 
      if(!a.Resolved && !b.Resolved && a.ActionDeadline<b.ActionDeadline){
        return -1;
      }
      if(a.Resolved && b.Resolved && a.ResolvedDate<b.ResolvedDate){
        return -1;
      }
        //a !b
      return 1})
    ;
  }
  isPastDate(deadline:Date){
    var nowDate = new Date();
    var newDeadline = new Date(deadline);
    return new Date(newDeadline.getFullYear(),newDeadline.getMonth(),newDeadline.getDate(),0,0,0,0) < new Date(nowDate.getFullYear(),nowDate.getMonth(),nowDate.getDate(),0,0,0,0)
  }
  switchAttachmentPanel(){
    if(this.question.QuestionAttachments.length==0){
      return;
    }
    this.expandedAttachmentPanel =! this.expandedAttachmentPanel;
  }
  switchPhotoPanel(){
    if(this.question.Photos.length==0){
      return;
    }else{
      this.expandedPhotoPanel = !this.expandedPhotoPanel;
    }
  } 
  switchActionPanel(){
    if(this.question.Actions.length>0){
      this.expandedActionPanel= !this.expandedActionPanel;
    }
  }
  isCompliant():boolean{
  if(this.question.ComplianceLimit<=0 || this.question.ComplianceLimit<this.question.Score || this.question.NASelected || this.question.QuestionAnswered == false || this.question.ExcludeScoreFromTotal ){
      return true;
    }
    return false;
  }
  isResolved():boolean{
    if(this.isCompliant()){
      return true;
    }
    var isResolved = true;
    this.question.Actions.forEach(e=>{
      if(!e.Resolved){
        isResolved = false;
      }
    })  
    return isResolved;
  }
  humanDate(date:Date):string{
    return this.util.humanDate(date);
  }
  shortDate(date:Date):string{
    return this.util.shortHumanDate(date);
  }
  downloadAttachment(attachment: QuestionAttachment){
    this.auditService.downloadAttachment(attachment.GUID).subscribe({
      next: (res: HttpResponse<Blob>) => this.downloadBlob(res, attachment.FileName),
      error: () => console.error('Failed to download attachment', attachment.GUID)
    });
  }
  private downloadBlob(response: HttpResponse<Blob>, fallbackName: string){
    const blob = response.body;
    if (!blob) {
      return;
    }
    let filename = fallbackName;
    const disposition = response.headers.get('content-disposition');
    if (disposition) {
      const match = disposition.match(/filename[^;=\n]*=((['\"]).*?\2|[^;\n]*)/i);
      if (match && match[1]) {
        filename = match[1].replace(/['"]/g, '');
      }
    }
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'attachment';
    link.click();
    window.URL.revokeObjectURL(url);
  }
  detailAction(actionID:number){
    this.router.navigate(['/actionv2'], {
      queryParams: {
        id: actionID,
        from: 'results',
        auditResultId: this.question.AuditResultID,
        questionId: this.question.QuestionID
      }
    });
  }
  editQuestion(){
    this.router.navigate(['/event-question-edit'], { queryParams: { eventId: this.eventId, auditResultId: this.question.AuditResultID, questionId: this.question.QuestionID, tab:'details' }, state: { question: this.question }});
  }
  photoSrc(GUID:string):string{
    return `${environment.apiUrl}audits/getphoto/`+GUID;
  }
  filenameReduction(filename:string):string{
    if(filename.length>40){
      return filename.substring(0,19) + "..." + filename.substring(filename.length - 18);
    }else{
      return filename
    }
  }
  stringReduction(text:string,characterLength:number){
    if(text.length>characterLength){
      return text.substring(0,characterLength) + "..."
    }
    return text;
  }
  allActionsResolved():boolean{
    return this.question.Actions.every(a => a.Resolved);
  }

  isImageAttachment(att: any): boolean{
    const mime = (att?.MimeType || '').toLowerCase();
    if (mime.startsWith('image/')){
      return true;
    }
    const name = (att?.FileName || '').toLowerCase();
    return /\.(png|jpe?g|gif|bmp|webp|svg)$/.test(name);
  }

  attachmentSrc(guid: string): string{
    return `${environment.apiUrl}audits/getattachment/${guid}`;
  }
}
